import store from '@/store';

const WEB_AI_WIDGET_APP_CODE_NAME = 'webaiwidgetmgr';
const WEB_AI_WIDGET_FEATURE_FLAGS = [
  'rollout.online_presence.web_ai_widget',
];
const FEATURE_FLAGS_TIMEOUT = 5000;
const DASHBOARD_ROUTE = { name: 'dashboard', replace: true };

const areFeatureFlagsLoaded = () => store.getters['BusinessStore/featureFlagsLoaded'];

const hasWebAiWidgetFeature = () => {
  const hasFeature = store.getters['BusinessStore/hasFeature'];
  return WEB_AI_WIDGET_FEATURE_FLAGS.some((featureName) => hasFeature(featureName));
};

const isWebAiWidgetInstalled = async () => {
  await store.dispatch('MainMenuStore/fetchApplicationsMenuItemsForce');
  const externalApps = store.getters['MainMenuStore/externalApplications'] || [];
  return externalApps.some((app) => app.app_code_name === WEB_AI_WIDGET_APP_CODE_NAME);
};

const createFeatureFlagsPromise = () => {
  if (areFeatureFlagsLoaded()) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const unwatch = store.watch(
      (state, getters) => getters['BusinessStore/featureFlagsLoaded'],
      (loaded) => {
        if (loaded) {
          unwatch();
          resolve();
        }
      },
    );
  });
};

const waitForFeatureFlagsWithTimeout = async () => {
  if (areFeatureFlagsLoaded()) {
    return true;
  }

  let timeoutId;
  try {
    await Promise.race([
      createFeatureFlagsPromise(),
      new Promise((resolve) => {
        timeoutId = setTimeout(() => resolve('timeout'), FEATURE_FLAGS_TIMEOUT);
      }),
    ]);
  } finally {
    if (timeoutId) clearTimeout(timeoutId);
  }

  return areFeatureFlagsLoaded();
};

const webAiWidgetRouteGuard = async (to, from, next) => {
  try {
    const featureFlagsLoaded = await waitForFeatureFlagsWithTimeout();

    const [isFeatureEnabled, isAppInstalled] = await Promise.all([
      Promise.resolve(featureFlagsLoaded && hasWebAiWidgetFeature()),
      isWebAiWidgetInstalled(),
    ]);

    if (isFeatureEnabled || isAppInstalled) {
      next();
      return;
    }

    next(DASHBOARD_ROUTE);
  } catch {
    next(DASHBOARD_ROUTE);
  }
};

export default webAiWidgetRouteGuard;
